var map = {
	"./AcademicClubs1.jpg": 1354,
	"./AcademicClubs2.jpg": 3429,
	"./AcademicClubs3.jpg": 9112,
	"./AcademicClubs4.jpg": 5851,
	"./AcademicClubs5.jpg": 5425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4224;